import * as XLSX from 'xlsx'
import React, { useRef, useState } from 'react'
import { PrimaryCta } from 'components'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'

export function ReportExport(_props) {
  const {
    query,
    queryParams = {},
    columns = [],
    title = 'export',
    fileName = 'reporte',
    preExport = null,
    dataFormat = 'json',
    ...rest
  } = _props
  const [startExport, setStartExport] = useState(false)
  const xlsBookRef = useRef(null)
  const xlsSheetRef = useRef(null)

  const {
    data: rawData,
    isLoading,
    isFetching,
    error,
  } = query({
    ...queryParams,
    skip: !startExport,
  })

  React.useEffect(() => {
    if (startExport && rawData && !isLoading && !isFetching) {
      let data = preExport ? preExport(rawData) : rawData
      xlsBookRef.current = XLSX.utils.book_new()
      if (dataFormat === 'json') {
        let reportData = prepareExportDataFromJson({ rows: data.rows, columns })
        xlsSheetRef.current = XLSX.utils.json_to_sheet(reportData, {
          cellDates: true,
        })
      } else {
        xlsSheetRef.current = XLSX.utils.aoa_to_sheet(data)
      }
      try {
        XLSX.utils.book_append_sheet(
          xlsBookRef.current,
          xlsSheetRef.current,
          title
        )
        XLSX.writeFile(xlsBookRef.current, `${fileName}.xlsx`)
      } catch (error) {
      }
      setStartExport(false)
    }
  }, [startExport, rawData, isLoading, isFetching])

  return (
    <PrimaryCta
      isSubmitting={isLoading}
      startIcon={<FontAwesomeIcon icon={faFileExcel} />}
      submittingLabel="Exportando"
      onClick={() => setStartExport(true)}
      {...rest}
    >
      Exportar
    </PrimaryCta>
  )
}

function processCell({ value, type = null, format = null }) {
  if (type === 'date') {
    return new Date(value)
  } else {
    return format ? format(value) : value
  }
}
function processSumRow({ accumulator, columnName, value, type }) {
  if (typeof type === 'string') {
    accumulator[columnName] = type
  } else if (type === true) {
    accumulator[columnName] = accumulator[columnName]
      ? accumulator[columnName] + value
      : value
  }
  return accumulator
}

function prepareExportDataFromJson({ rows, columns }) {
  const resultData = rows.reduce(
    (acc, rawRow) => {
      let row = {}
      columns.forEach((column) => {
        try {
          row[column.headerName] = processCell({
            value: rawRow[column.field],
            type: column?.reportType,
            format: column?.reportFormat,
          })
          acc.sumRow = processSumRow({
            accumulator: acc.sumRow,
            columnName: column.headerName,
            value: rawRow[column.field],
            type: column?.reportSum,
          })
        } catch (error) {
        }
      })
      acc.dataRows.push(row)
      return acc
    },
    { dataRows: [], sumRow: {} }
  )
  return [...resultData.dataRows, resultData.sumRow]
}

function prepareExportDataFromArrayofArrays({ rows, columns }) {
  const resultData = rows.reduce(
    (acc, rawRow) => {
      let row = {}
      columns.forEach((column) => {
        try {
          row[column.headerName] = processCell({
            value: rawRow[column.field],
            type: column?.reportType,
            format: column?.reportFormat,
          })
          acc.sumRow = processSumRow({
            accumulator: acc.sumRow,
            columnName: column.headerName,
            value: rawRow[column.field],
            type: column?.reportSum,
          })
        } catch (error) {
        }
      })
      acc.dataRows.push(row)
      return acc
    },
    { dataRows: [], sumRow: {} }
  )
  return [...resultData.dataRows, resultData.sumRow]
}
